import {
  FluidAddressFields,
  FluidFieldTranslations,
  FluidLanguage,
  FluidTranslationSet,
} from '@lmig/fluid-core';

export const gbAddressTranslations: FluidTranslationSet<
  FluidFieldTranslations<FluidAddressFields>
> = {
  [FluidLanguage.ENGLISH]: {
    addressTitle: {
      label: 'Address',
    },
    addressLineOne: {
      label: 'Address Line 1',
      validation: {
        required: 'This field is required',
      },
    },
    addressLineTwo: {
      label: 'Address line 2',
    },
    country: {
      label: 'Country',
    },
    townOrCity: {
      label: 'Town/City',
    },
    countyOrProvince: {
      label: 'County',
    },
    postOrZipCode: {
      label: 'Postcode',
      validation: {
        required: 'You must enter a postcode!',
        pattern: 'You must enter a valid UK postcode!',
      },
    },
    regionOrLocality: {
      label: 'Region',
    },
  },
};
